import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './row.module.scss';

type Props = {
  className?: string;
  id?: string;
  dataTestId?: string;
};

export const Row: FC<Props> = ({ children, className, id, dataTestId }) => {
  const rowClass = classNames(styles.row, className);
  return (
    <div className={rowClass} id={id} data-test-id={dataTestId}>
      {children}
    </div>
  );
};
